'use client'

import { useEffect } from 'react'

export function HeartbeatLoader({ project }: { project: string }) {
  useEffect(() => {
    if (document.querySelector('script[data-heartbeat="status-xoka"]')) return
    const s = document.createElement('script')
    s.src = `https://status.xoka.com/heartbeat.js?project=${encodeURIComponent(project)}`
    s.defer = true
    s.dataset.heartbeat = 'status-xoka'
    document.body.appendChild(s)
  }, [project])
  return null
}
